// src/shared/reconcile-as-at.js - the "as at" date of a leave-balance upload (v136.14, 19 Oct 2026).
//
// Zero dependencies, on purpose: the Worker (src/worker/routes/balances-admin.js) and the upload
// screen (src/uploads/balanceReconcile.js) both check the date with THIS function, so the screen
// refuses exactly what the Worker would refuse, in the same words.
//
// Why the date exists: HR (Amanah) deducts leave only once it has happened. The upload used to add
// back EVERY holiday and sick day on the rota for the year, as if HR had already deducted all of
// them, so anyone with leave HR had not yet processed (booked ahead, or taken but not yet entered)
// was overstated by those days. Now the upload adds back only rota leave dated on or before this
// date, and Shift deducts the rest as it happens. See docs/leave-balance-upload-spec.md.
//
// checkAsAt(raw, year, today) -> { asAt, defaulted } | { error }
//   raw   : the date the manager gave (YYYY-MM-DD), or blank for "today"
//   year  : the year the balances are for
//   today : today's date in Dubai (YYYY-MM-DD)
// Rules: a real date, inside the upload's year, not in the future. Blank means today, and for a
// year already over it means that year's 31 December (every day of it has happened).

function isRealDate(s) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
  const d = new Date(s + 'T00:00:00Z');
  return !isNaN(d.getTime()) && d.toISOString().slice(0, 10) === s;
}

export function checkAsAt(raw, year, today) {
  const y = String(year);
  const t = String(today || '').slice(0, 10);
  if (raw === undefined || raw === null || String(raw).trim() === '') {
    if (t.slice(0, 4) > y) return { asAt: y + '-12-31', defaulted: true };
    if (t.slice(0, 4) < y) return { error: 'The year ' + y + ' has not started yet, so there is no leave to count.' };
    return { asAt: t, defaulted: true };
  }
  const s = String(raw).trim();
  if (!isRealDate(s)) return { error: 'The "as at" date is not a real date. Use the date your HR export was taken.' };
  if (s.slice(0, 4) !== y) return { error: 'The "as at" date must be in ' + y + ', the year these balances are for.' };
  if (s > t) return { error: 'The "as at" date cannot be in the future. Use the date your HR export was taken.' };
  return { asAt: s, defaulted: false };
}
